const spanishTranslations = {
    common: {
        accountEndingIn: 'Cuenta que termina en {{last4digits}}',
        amount: 'Monto',
        back: 'Volver',
        done: 'Listo',
        cancel: 'Cancelar',
        close: 'Cerrar',
        date: 'Fecha',
        lostOrStolen: 'Reportar Tarjeta Perdida o Robada',
        description: 'Descripción',
        next: 'Siguiente',
        onlineChat: 'Chat en Línea',
        purchase: 'Compra',
        replaceYourCard: 'Reemplazar Su Tarjeta',
        selectAll: 'Seleccionar Todo',
        submit: 'Enviar',
        unselectAll: 'Deseleccionar Todo'
    },
    cantProcess: {
        cantProcessOnline: 'No podemos procesar su solicitud en línea.',
        forAssistance: ' para obtener ayuda.',
        pleaseReachOut: 'Comuníquese con nosotros a través del '
    },
    closeConfirmation: {
        closingWillCancel: 'El cierre cancelará la solicitud. ¿Desea continuar?',
        noDontCancel: 'No Cancelar',
        yesCancelRequest: 'Sí, Cancelar la Solicitud',
        yourProgressWillNot: 'Su progreso no será guardado.'
    },
    exitConfirmation: {
        changeAddress: 'Cambiar dirección',
        changingYourAddress: 'Para cambiar su dirección, se requerirá una verificación adicional. Le solicitamos que se comunique con nosotros al ',
        exitingWillCancel: 'Al salir, se cancelará su solicitud',
        goBack: 'Volver'
    },
    reasonSelection: {
        damagedCardHeading: 'Tarjeta Dañada',
        damagedCardBody: 'Recibirás una tarjeta de reemplazo con el mismo número de cuenta, para que puedas seguir usando la cuenta hasta que llegue el reemplazo.',
        ifYouCantFind: 'Si no puede encontrar su tarjeta,',
        makeASelection: 'Por favor haga una selección.',
        neverReceivedCard: 'Nunca Recibió la Tarjeta',
        pleaseTellUsMore: 'Por favor, cuéntenos más sobre su situación',
        reportIt: 'repórtela como perdida o robada',
        yourPreviouslyIssuedCard: 'Su tarjeta emitida anteriormente se cancelará, y recibirá una tarjeta de reemplazo con un nuevo número de cuenta.'
    },
    selectAccount: {
        beforeMaking: ' before making another request.',
        businessDays: ' 7-10 business days ',
        cardOnTheWay: 'P.T.: A replacement card is on the way. Please allow ',
        selectOneOrMore: 'Por favor seleccione uno o más tarjetahabiente.',
        whichCardholder: '¿Cuál de los titulares de la tarjeta en su cuenta necesita una tarjeta nueva?'
    },
    selectCardholder: {
        contactUs: 'Use el ',
        toCommunicate: ' para comunicarse con nosotros.',
        eligibleCardholders: 'Los titulares de la tarjeta elegibles se muestran a continuación. ¿Falta un titular de tarjeta?',
        selectOne: 'Por favor seleccione uno tarjetahabiente.'
    },
    recognizeTransaction: {
        previousCardActivated: 'Su tarjeta emitida anteriormente se envió previamente activada, por lo que queremos asegurarnos de que no haya cargos fraudulentos.',
        doYouRecognize: '¿Reconoces todas estas transacciones?',
        noDontRecognize: 'NO, NO LAS RECONOZCO',
        yesRecognize: 'SÍ, LAS RECONOZCO'
    },
    errorBoundary: {
        title: 'Tenemos problemas para cargar esta página',
        pleaseTryAgain: 'Inténtelo nuevamente más tarde o contáctenos a través del '
    },
    cantVerify: {
        address: 'Dirección',
        forAssistance: ' para obtener ayuda.',
        havingTroubleVerify: 'Tenemos problemas para verificar su identidad',
        noDontRecognize: 'NO, NO LAS RECONOZCO',
        noTransactionsFound: 'No se encontraron transacciones',
        pleaseReachOut: 'Comuníquese con nosotros a través del ',
        purchaseLocation: 'Ubicación de compra',
        purchase: 'Compra',
        referenceNumber: 'Número de Referencia',
        refund: 'Reembolso',
        yesRecognize: 'SÍ, LAS RECONOZCO'
    },
    whenLost: {
        cardStolenTitle: '¿Cuando te robaron tu tarjeta?',
        dateCannotBeBeforeMinimum: 'La fecha no puede ser anterior al 1 de enero de 1970',
        dateMustBeValid: 'La fecha debe ser una fecha de calendario válida MM/DD/AAAA',
        dontKnow: 'No sé la fecha',
        futureDate: 'La fecha debe ser anterior o igual a hoy',
        lostCardTitle: '¿Cuándo se perdió su tarjeta?',
        pleaseSelect: 'Por favor seleccione una fecha para continuar'
    },
    unableSubmit: {
        weAreUnable: 'No podemos enviar su solicitud',
        pleaseContact: 'Por favor contáctenos inmediatamente a través del '
    },
    summaryDetails: {
        addToYourDigital: 'Agregue a su billetera digital',
        allowUp: 'Allow up to 7 days',
        beforeSubmitting: ' antes de enviar su solicitud.',
        cardholderRequestFailed: 'Su solicitud para el titular de la tarjeta mencionado a continuación no se realizó; inténtelo nuevamente ',
        deliveryDetails: 'Detalles de la Entrega',
        deliveryMethod: 'Método de Entrega',
        expectedDelivery: 'Entrega prevista de 7 a 10 días laborables',
        forYourAccount: ' for your account to reflect these new details.',
        freeShipping: 'Envío gratis',
        itCanTake: '. Las actualizaciones de seguimiento pueden tardar hasta dos días hábiles en aparecer.',
        manageProfile: 'Administrar Perfil',
        needMoreHelp: '¿Necesita más ayuda? Use el ',
        note: 'No se verán afectados los estados de cuenta electrónicos, los métodos de pago, los pagos programados y Autopay.',
        noteTitle: 'Nota: ',
        noteWithUpdate: 'No se verán afectados los estados de cuenta electrónicos, los métodos de pago, los pagos programados y Autopay. Necesitará actualizar la información de su tarjeta con cualquier empresa o servicio que le facture automáticamente.',
        onceYouSubmit: 'Una vez que envíe esta solicitud, no podrá revertirse. Puede seguir usando su cuenta hasta que llegue la nueva tarjeta.',
        onceYouSubmitMisplaced: 'Una vez que envíe esta solicitud, no podrá revertirse. Recibirá una tarjeta de reemplazo con el mismo número de cuenta. Si encuentra su tarjeta extraviada, puede continuar usándola hasta que active su nueva tarjeta. ',
        onceYouSubmit7days: 'P.T.: Once you submit this request it can’t be reversed. Cards for the users below will no longer work and will be reissued with a new account number. ',
        onlineChat: 'Online Chat',
        payEasily: 'PAGUE FÁCILMENTE: EN CUALQUIER LUGAR, EN CUALQUIER MOMENTO.',
        pleaseReview: 'Por favor, revise la siguiente información cuidadosamente antes de enviar',
        requestDetails: 'Detalles de la Solicitud',
        secureWay: ' una forma segura y conveniente de pagar.',
        shippingAddress: 'Dirección de Envío',
        standardDelivery: 'Entrega estándar antes del USPS',
        theFollowingCardholders: 'Se emitirá una nueva tarjeta para {{accountName}} los siguientes usuarios de su cuenta:',
        toCommunicateWithUs: ' para comunicarse con nosotros.',
        trackYourCard: 'Rastrear su tarjeta',
        wellNotifyYou: 'Le notificaremos cuando su tarjeta se envíe; puede seguir usando su cuenta hasta que llegue la nueva tarjeta. Hemos enviado un correo electrónico de confirmación a {{email}}.',
        wrongAddress: '¿La dirección está incorrecta? Actualícela en ',
        yourReplacementWillBe: 'Su tarjeta de reemplazo se enviará a la dirección postal actual en su perfil:',
        shippedNotify: 'Le notificaremos cuando su tarjeta se envíe; puede seguir usando su cuenta hasta que llegue la nueva tarjeta. Hemos enviado un correo electrónico de confirmación a {{ variables.email }}',
        yourReplacementHasBeen: 'Su tarjeta de reemplazo ha sido ordenada y deberá llegar dentro de 7 a 10 días hábiles',
        toCheckYourCard: 'Para consultar el estado del envío de su tarjeta, visite '
    },
    reasonSelectionLostStolen: {
        cardDamaged: 'Si su tarjeta está dañada, puede ',
        freezeAccount: 'Congelar la Cuenta',
        lostCardHeading: 'Tarjeta Perdida',
        lostCardBody: 'Su tarjeta se cancelará y recibirá una tarjeta de reemplazo con un nuevo número de cuenta.',
        misplacedCardHeading: 'Tarjeta Extraviada en el Hogar',
        misplacedCardBody: "Recibirá una tarjeta de reemplazo con el mismo número de cuenta. Si le preocupa que el número de su cuenta haya sido comprometido, por favor, seleccione 'Tarjeta Perdida' para que se emita un nuevo número de cuenta.",
        needTime: '¿Necesita tiempo para buscar su tarjeta? Rechazaremos compras nuevas hasta que descongele su cuenta.',
        requestReplacement: 'solicitar una de reemplazo',
        stolenCardHeading: 'Tarjeta Robada',
        stolenCardBody: 'Su tarjeta se cancelará y recibirá una tarjeta de reemplazo con un nuevo número de cuenta.'
    },
    tempBlock: {
        yourAccount: 'Su cuenta está bloqueada temporalmente',
        forYourProtection: 'Para su protección, comuníquese con nosotros al ',
        soWeCanReview: ' para que podamos revisar su actividad reciente. Si detectamos fraude, abriremos un reclamo y le enviaremos una tarjeta nueva.',
        fraudPrevention: 'Sugerencias y Preguntas Frecuentes sobre Prevención de Fraude',
        fraudLiabilityBold: '$0 Responsabilidad por Fraude',
        fraudLiability: 'Usted nunca será responsable por cargos no autorizados'
    }
};
export default spanishTranslations;
//# sourceMappingURL=es.js.map